export const translation = {
  landing: {
    title: "LIFE IS ABOUT CREATING AND LIVING EXPERIENCE THAT ARE WORTH SHARING. ",
    highlightedText: "HEY, THIS IS TUSHAR SINGH, A SOFTWARE DEVELOPER BRIDGING THE WORLDS OF TECHNOLOGY, DESIGN, & PRODUCT",
  },
  about: "Currently building at Vcheck, where I develop scalable applications, contribute to product design, and assist in data-driven decision-making, uncovering user insights & product opportunities."
};

export const SidebarLinks = [
  // {
  //   label: "ABOUT ME",
  //   url: "#about",
  //   isInternal: true
  // },
  // {
  //   label: "WORK",
  //   url: "#work",
  //   isInternal: true
  // },
  {
    label: "BLOG",
    url: "https://tusharcero.substack.com/",
    isInternal: false
  },
  {
    label: "RESUME",
    url: "https://docs.google.com/document/d/1RVQZ3EiT_Q_Kr_tCqsJ3JsNTVLmKaW-vt0QQYlwQA-Y/edit?usp=sharing",
    isInternal: false
  },
  {
    label: "EMAIL",
    url: "mailto:tusharsingh.contact@gmail.com",
    isInternal: false
  }
];

export const SocialLinks = [
  {
    label: "GITHUB",
    url: "https://github.com/tushar-cero",
    icon: "fa-github",
    ariaLabel: "Github"
  },
  {
    label: "BEHANCE",
    url: "https://www.behance.net/tushar_cero",
    icon: "fa-behance",
    ariaLabel: "Behance"
  },
  {
    label: "LINKEDIN",
    url: "https://www.linkedin.com/in/tushar-cero/",
    icon: "fa-linkedin",
    ariaLabel: "Linkedin"
  },
  {
    label: "TWITTER",
    url: "https://twitter.com/tushar_cero",
    icon: "fa-twitter",
    ariaLabel: "Twitter"
  }
];

export const FooterSocialLinks = [
  {
    name: 'linkedin',
    url: 'https://www.linkedin.com/in/tushar-cero/',
  },
  {
    name: 'twitter',
    url: 'https://twitter.com/tushar_cero',
  },
  {
    name: 'github',
    url: 'https://github.com/tushar-cero',
  }
];

export const CarouselItems = [
  {
    icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} color={"#ffffff"} fill={"none"}>
      <path d="M17 8L18.8398 9.85008C19.6133 10.6279 20 11.0168 20 11.5C20 11.9832 19.6133 12.3721 18.8398 13.1499L17 15" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
      <path d="M7 8L5.16019 9.85008C4.38673 10.6279 4 11.0168 4 11.5C4 11.9832 4.38673 12.3721 5.16019 13.1499L7 15" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
      <path d="M14.5 4L9.5 20" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>,
    title: "Software Development",
    description: "I craft thoughtful digital experiences & blend design with development that harmonizes aesthetics & function. I turn design ideas into working, polished interfaces without losing their essence.",
    imageClass: 'development'
  },
  {
    icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} color={"#ffffff"} fill={"none"}>
      <path d="M7.49478 13.753C10.5833 10.1644 17.5788 3.15478 20.5387 3.00445C22.3699 2.82906 18.7218 9.32547 10.0785 16.4339M11.4581 10.0449L13.7157 12.3249M3 20.8546C3.70948 18.3472 3.26187 19.5794 3.50407 16.6919C3.63306 16.2644 3.89258 14.9377 5.51358 14.2765C7.35618 13.5249 8.70698 14.6611 9.05612 15.195C10.0847 16.3102 10.2039 17.6952 9.05612 19.2774C7.9083 20.8596 4.50352 21.2527 3 20.8546Z" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>,
    title: "Product Design",
    description: "I enjoy shaping ideas into wireframes & intuitive design systems. My focus lies in crafting useful, beautiful products that serve real needs. Every decision balances creativity with practical functionality.",
    imageClass: 'design'
  },
  {
    icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} color={"#ffffff"} fill={"none"}>
      <path d="M21 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V3" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M5 20C6.07093 18.053 7.52279 13.0189 10.3063 13.0189C12.2301 13.0189 12.7283 15.4717 14.6136 15.4717C17.8572 15.4717 17.387 10 21 10" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>,
    title: "Product Management",
    description: "I help teams stay focused & aligned toward shared goals & outcomes. Organizing people, ideas, & tasks feels natural & rewarding to me. I collaborate closely with engineers, designers, & product leads.",
    imageClass: 'management'
  }
];